import { render, staticRenderFns } from "./ViewIcon.vue?vue&type=template&id=9b3f9f74&scoped=true"
import script from "./ViewIcon.vue?vue&type=script&lang=js"
export * from "./ViewIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3f9f74",
  null
  
)

export default component.exports